<ion-header *ngIf="isNative">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onCloseModal()">Cancel</ion-button>
    </ion-buttons>
    <ion-title>Select/Verify Location</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCloseModal()">Done</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
  <ng-container *ngIf="!pins$ || pinList">
    <curbnturf-coordinates-map
      (locationClicked)="locationClicked($event)"
      (close)="onCloseModal()"
      [pins]="pinList || []"
      [center]="center"
      [draggable]="draggable"
      [text]="text"
    >
    </curbnturf-coordinates-map>
  </ng-container>
</ion-content>
